import { Chip, ChipProps } from '@mui/material';
import type { RunOutcome } from '../types';

export const OUTCOME_LABELS: Record<RunOutcome, string> = {
  CREATED: 'Created',
  WOULD_CREATE: 'Would create',
  ADOPTED: 'Adopted',
  FLAGGED: 'Flagged',
  UPDATED: 'Updated',
  NO_CHANGE: 'No change',
  SKIPPED: 'Skipped',
  CANCELLED: 'Cancelled',
  HELD: 'Held',
  FAILED: 'Failed'
};

const COLORS: Partial<Record<RunOutcome, ChipProps['color']>> = {
  CREATED: 'success',
  WOULD_CREATE: 'success',
  FLAGGED: 'warning',
  HELD: 'warning',
  FAILED: 'error',
  UPDATED: 'info',
  ADOPTED: 'info'
};

export default function OutcomeChip({ outcome }: { outcome: RunOutcome }) {
  const color = COLORS[outcome] ?? 'default';
  return (
    <Chip
      size="small"
      variant={color === 'default' ? 'outlined' : 'light'}
      color={color}
      label={OUTCOME_LABELS[outcome] ?? outcome}
      sx={{ fontWeight: 600 }}
    />
  );
}
